import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import TimeSheetRow from './UserSheetsRow';
import PayrollReportCreator from '../payroll/PayrollReportCreator';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import RequestVacation from '../RequestVacation';
import Time from '../../Time';

class UserTimeSheets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payrollList:[],
      payrollEmployee:"",
      payrollGenerator:false,
      payrollPeriod:'',
      requestVacation:false,
    };

    this.callTimeSheets = this.callTimeSheets.bind(this);
    this.formStartDate = React.createRef();
    this.formEndDate = React.createRef();
    this.openCloseVacationRequest = this.openCloseVacationRequest.bind(this);
  }

  //Make a GET request to retrieve the user Timeshifts
  callTimeSheets = async(period) =>{
    this.setState({payrollList:[]})

    let startingDate = period.start;
    let endingDate = period.end;

    const APIlink = "https://dashboard.realsexdoll.info/php/payroll/getuserpayroll.php?"
    let linkEmployeeName = "employeeName="+this.props.user;
    let linkStartDate = "&startDate="+startingDate;
    let linkEndDate = "&endDate="+endingDate+"T23:59";

    //Example of the full API Call
    //https://dashboard.realsexdoll.info/php/getuserpayroll.php?employeeName=Pedro&startDate=2022-10-03&endDate=2022-10-12
    
    
    let APICall = APIlink+linkEmployeeName+linkStartDate+linkEndDate;

    //Here is where the API request happens and we get the result
    let fetchRequest = await fetch(APICall);
    const result = await fetchRequest.json();
    this.setState({payrollList:result});

  }

   //Every time you change the period
   changePeriod = (selectedPeriod) =>{

    this.setState({payrollPeriod:selectedPeriod.value})
    console.log(selectedPeriod.value);
    this.callTimeSheets(selectedPeriod.value);
  }

  //Opens and closes the ReportGenerator
 
  openCloseVacationRequest = () =>{
    let vacStatus = this.state.requestVacation
    this.setState({requestVacation:!vacStatus});
  }


  componentDidMount = () =>{

  }

  render() {

     //Render the Vacation Requester
     let vacationRequesterHTML;
    
     if(this.state.requestVacation){
      vacationRequesterHTML = <RequestVacation 
           close={this.openCloseVacationRequest}
           user={this.props.user}
         />
     }

    let selectedPeriod;
    const periodOptions = Time.PayrollDates( {horizonYears: 2});
    const selectPeriods = 
      <Select
          options={periodOptions}
          value={selectedPeriod}
          onChange={this.changePeriod}
      />

    let timeSheetListHTML;

    if(this.state.payrollList.length > 0){timeSheetListHTML = this.state.payrollList.map((row, index) =>
      <TimeSheetRow
        key={index}
        Id ={row.Id}
        Username = {row.Username}
        OriginalStartTime = {row.OriginalStartTime}
        OriginalEndTime = {row.OriginalEndTime}
        StartTime = {row.StartTime}
        EndTime = {row.EndTime}
        HRStartTime = {row.HrStartTime}
        HREndTime = {row.HrEndTime}
        BreakMinutes = {row.BreakMinutes}
        UserVerified = {row.UserVerified}
        UserFlagged = {row.UserFlagged}
        FlagReason = {row.FlagReason}
        WorkLocation = {row.WorkLocation}
        updateRows = {this.callTimeSheets}
      />
    )}

    return(
      <div>
        {vacationRequesterHTML}
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window payroll-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <div className='row m2'>
                    <div className='col-4'>
                      <h2>Your Time Sheets</h2>
                    </div>
                    <div className='col-8 d-flex flex-row-reverse'>
                      <button onClick={this.openCloseVacationRequest} className='mx-1'>Request Vacation</button>
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-4'>
                      <label className="form-label">Employee</label>
                      <p>{this.props.user}</p>
                    </div>
                    <div className='col-4'>
                        <label className="form-label">Payroll Period:</label>
                        {selectPeriods}
                    </div>
                  </div>
                  <div className='payroll-section'>
                    <div className='payroll-table-container'>
                      <table className="table payroll-table">
                        <thead>
                            <tr>
                              <th>Shift #</th>
                              <th>Name</th>
                              <th>Logged Start Date</th>
                              <th>Logged End Date</th>
                              <th>Employee Start Date</th>
                              <th>Employee End Date</th>
                              <th>Unpaid Breaks</th>
                              <th>Verify Shift</th>
                              <th>Correction Request</th>
                              <th>Request Reason</th>
                              <th>Total Time</th>
                              <th>Location</th>
                              <th>Screenshot</th>
                            </tr>
                        </thead>
                        <tbody>
                          {timeSheetListHTML}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default UserTimeSheets;